import React from "react";
import _ from "lodash";
import moment from "moment";
import { FormattedMessage, injectIntl } from "react-intl";
import classnames from "classnames";

import { Close } from "components/Icons";

import "./style.scss";

interface IProps {
  filter: any;
  fixedFilters: string[];
  onRemove: (key: string) => void;
  intl: any;
  filterOpened: boolean;
}

class SelectedFilters extends React.Component<IProps> {
  private formatDateValue = value => {
    const shouldFormat = moment(value).isValid() && !_.isNumber(value);
    return shouldFormat ? moment(value).format("DD/MM/YYYY") : value;
  };

  private renderTag = key => {
    const {
      filter,
      intl: { formatMessage }
    } = this.props;

    // hack, if a filter has been stored with empty from or to date
    // it shouldn't be stored in the first place. Remove it.
    if (
      !filter[key].from &&
      !filter[key].to &&
      (filter[key].hasOwnProperty("from") || filter[key].hasOwnProperty("to"))
    ) {
      delete filter[key];
      return;
    }

    if (typeof filter[key] === "boolean") {
      return _.startCase(key);
    } else if (
      typeof filter[key] === "object" &&
      filter[key].from &&
      filter[key].to
    ) {
      const dateTag = `${this.formatDateValue(
        filter[key].from
      )} - ${this.formatDateValue(filter[key].to)}`;

      return dateTag;
    } else if (
      typeof filter[key] === "object" &&
      filter[key].from &&
      !filter[key].to
    ) {
      const dateTag = `${formatMessage({ id: "FROM" })}: ${this.formatDateValue(
        filter[key].from
      )}`;
      return dateTag;
    } else if (
      typeof filter[key] === "object" &&
      !filter[key].from &&
      filter[key].to
    ) {
      const dateTag = `${formatMessage({ id: "TO" })}: ${this.formatDateValue(
        filter[key].to
      )}`;
      return dateTag;
    } else if (typeof filter[key] === "object" && _.has(filter[key], "value")) {
      return filter[key].label;
    } else {
      return filter[key];
    }
  };

  public render() {
    const { filter, fixedFilters, onRemove, filterOpened } = this.props;

    return (
      <div
        className={classnames(
          "selected-filters",
          !filterOpened ? "filter-closed" : ""
        )}
      >
        <FormattedMessage id="SELECTED_FILTERS" />
        {Object.keys(filter).map(
          key =>
            filter[key] && (
              <span
                className="filter-block"
                key={key}
                onClick={() => !_.includes(fixedFilters, key) && onRemove(key)}
              >
                {this.renderTag(key)} <Close className="close-btn" />
              </span>
            )
        )}
      </div>
    );
  }
}

export default injectIntl(SelectedFilters);
